<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">
        <section class="hero-section ptb-100" style="background:#00A39C">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-9 col-lg-7">
                        <div class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                            <h1 class="text-white mb-0">Venta de bases</h1>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="customer-review-section ptb-100 gray-light-bg">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="text-center mb-5">
                            <h5 class="text-muted">Adquiere las bases de la subasta haciendo clic en “Comprar ahora”</h5>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                        <h2 class="d-none">Información no disponible</h2>
                        <!--<div class="single-promo-hover single-promo-1 rounded text-center white-bg h-100 mb-4 w-50 mx-4 d-none">
                            <div class="d-flex flex-sm-row flex-column">
                                <div class="mb-">
                                     <el-image class="w-100 rounded-l" style="border-radius:20px;" :src="'https://apv.serpar.gob.pe/writable/uploads/services/subastas2.jpg'"></el-image>
                                </div>
                                <div class="my-4">
                                    <p class="mb-1"><strong>Venta de Bases</strong></p>
                                    <h5>Subasta de alquiler de lotes para negocio (2021)</h5>
                                    <h3 class="text-primary" v-text="'S/ 15.00'"></h3>
                                    <div class="btn solid-btn mt-1" @click="openModal(2)">Comprar ahora</div>
                                </div>
                            </div>
                        </div>-->
                        <div class="single-promo-hover single-promo-1 rounded text-center white-bg h-100 mb-4 w-50 mx-4">
                            <div class="d-flex flex-sm-row flex-column">
                                <div class="mb-">
                                     <el-image class="w-100 rounded-l" style="border-radius:20px; height: 250px;width: 260px !important;"
                                     :src="'https://www.serpar.gob.pe/wp-content/uploads/2026/10/Subasta-002-2026-2da-convocatoria-1.jpg'"></el-image>
                                </div>
                                <div class="my-4">
                                    <p class="mb-1"><strong>Venta de Bases</strong></p>
                                    <h5>Subasta pública N° 002 - 2026 (Segunda convocatoria)</h5>
                                    <h3 class="text-primary" v-text="'S/ 50.00'"></h3>
                                    <div class="btn solid-btn mt-1" @click="openModal(1)">Comprar ahora</div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </section>

        <el-dialog title="Compra de bases" :visible.sync="dialogVisible" width="40%" top="3vh" class="mdsubasta" :close-on-click-modal="false">
            <el-steps :active="active" align-center>
                <el-step title="Datos personales"></el-step>
                <el-step title="Datos de facturación"></el-step>
                <el-step title="Resumen"></el-step>
            </el-steps>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <div class="step1 mt-2" v-if="active == 0">
                    <div class="row">
                        <div class="col-sm-6">
                            <el-form-item label="Documento" prop="tdocument" class="mb-0">
                                <el-select v-model="ruleForm.tdocument" placeholder="Selecciona" class="w-100" @change="ruleForm.ndocument=''">
                                    <el-option v-for="item in listDocuments" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="N° Documento" prop="ndocument" class="mb-0">
                                <el-input v-model="ruleForm.ndocument"
                                :maxlength="maxlength"
                                @keypress.native="isNumber($event)"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <el-form-item label="Nombres y apellidos completos" prop="firstname" class="mb-0">
                        <el-input v-model="ruleForm.firstname" maxlength="50"></el-input>
                    </el-form-item>
                    <div class="row">
                        <div class="col-sm-6">
                            <el-form-item label="Celular" prop="phone1" class="mb-4">
                                <el-input v-model="ruleForm.phone1" maxlength="9" @keypress.native="isNumber($event)"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="Teléfono fijo" class="mb-4">
                                <el-input v-model="ruleForm.phone2" maxlength="9" @keypress.native="isNumber($event)"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-left">Email*</label>
                        <div class="col-sm-10">
                            <el-form-item prop="email"  class="mb-0">
                                <el-input v-model="ruleForm.email" maxlength="100"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="step1 mt-4" v-if="active == 1">

                  <div class="row mb-4">
                        <div class="col-sm-6">
                            <el-form-item label="Documento" prop="voucher" class="mb-0">
                                <el-select v-model="ruleForm.voucher" placeholder="Selecciona" class="w-100"
                                @change="changeTpodocument">
                                <el-option key="B" label="Boleta" value="B"></el-option>
                                <el-option key="F" label="Factura" value="F"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="N° Documento" prop="fndoc" class="mb-0">
                                <el-input v-model="ruleForm.fndoc"
                                :placeholder="placeHolder.voucher"
                                :maxlength="maxlengthTwo"
                                @keypress.native="isNumberTwo($event)"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <!--
                    <el-form-item label="Comprobante" label-width="120px" class="mb-4" prop="fndoc">
                        <el-input
                        :placeholder="placeHolder.voucher"
                        v-model="ruleForm.fndoc"
                        class="input-with-select"
                        size="medium"
                        :clearable="true"
                        :maxlength="maxlengthTwo"
                        @keypress.native="isNumberTwo($event)">
                            <el-select v-model="ruleForm.voucher" slot="prepend" placeholder="Seleccione" @change="changeTpodocument">
                                <el-option key="B" label="Boleta" value="B"></el-option>
                                <el-option key="F" label="Factura" value="F"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    -->
                    <el-form-item :label="placeHolder.namebussines" prop="fname" size="medium">
                        <el-input v-model="ruleForm.fname" :placeholder="placeHolder.namebussines"></el-input>
                    </el-form-item>
                    <el-form-item label="Celular" prop="fphone">
                        <el-input type="fphone" v-model.number="ruleForm.fphone" placeholder="N° de celular" maxlength="9" size="medium"></el-input>
                    </el-form-item>
                    <el-form-item label="Email" prop="femail">
                        <el-input v-model="ruleForm.femail" placeholder="Correo electrónico" size="medium"></el-input>
                    </el-form-item>
                </div>
                <div class="step1 mt-2" v-if="active == 2">

                    <el-divider content-position="left">Datos personales</el-divider>
                    <div class="ml-5">Documento: {{ruleForm.ndocument}}</div>
                    <div class="ml-5">Nombres y apellidos: {{ruleForm.firstname}}</div>
                    <div class="ml-5">Celular: {{ruleForm.phone1}} / Teléfono: {{phone2}}</div>
                    <div class="ml-5">Email: {{ruleForm.email}} <span class="text-muted" style="font-size:10px;">(aquí se enviarán las bases)</span></div>

                    <el-divider content-position="left">Datos de facturación</el-divider>
                    <div class="ml-5">Comprobante: {{placeHolder.voucher}} {{ruleForm.fndoc}}</div>
                    <div class="ml-5">{{placeHolder.namebussines}} {{ruleForm.fname}}</div>
                    <div class="ml-5">Celular: {{ruleForm.fphone}}</div>
                    <div class="ml-5">Email: {{ruleForm.femail}}</div>

                    <el-divider class="mb-2" content-position="left">Total a pagar</el-divider>
                    <h3 class="text-primary my-0 text-center" v-text="ruleForm.precio == 1 ? 'S/ 50.00' : 'S/ 15.00'"></h3>
                    <el-form-item prop="terms" required>
                        <el-checkbox v-model="ruleForm.terms" name="terms">He leído y acepto los
                            <a href="https://www.serpar.gob.pe/wp-content/uploads/2021/01/terminos.pdf" target="_blank"><b>Términos y Condiciones</b></a></el-checkbox>
                    </el-form-item>

                </div>
            </el-form>
            <el-divider class="mb-3 mt-2"></el-divider>
            <button class="btn outline-btn mb-3" @click.prevent="submitForm('ruleForm')">{{(active == 2)? 'Ir a pagar':'Siguiente'}}</button>

        </el-dialog>


    </div>
</template>
<script>
import data from "@/data/common";
export default {
    data() {
        var validateDocument = (rule, value, callback) => {
          if(this.ruleForm.tdocument == '01' && value.length<8)
              return callback(new Error('DNI son 8 dígitos'))
          else if(this.ruleForm.voucher == 'B' && value.length<8)
              return callback(new Error('DNI son 8 dígitos'))
          else if(this.ruleForm.voucher == 'F' && value.length<10)
              return callback(new Error('RUC son 11 dígitos'))
          else
              return callback()
        }
        return {
            fullscreenLoading: false,
            dialogVisible: false,
            active: 0,
            totalSteps: 3,
            placeHolder:{voucher: 'DNI', namebussines: 'Nombres'},
            listBilling: data.billing,
            listDocuments: data.document,
            ruleForm:{
                precio: 1,
                tdocument: '01',
                ndocument: '',
                firstname: '',
                phone1: '',
                phone2: '',
                address: '',
                email: '',
                voucher: 'B',
                fndoc: '',
                fname: '',
                fphone: '',
                femail: '',
                terms: false,
            },
            rules:{
                tdocument: [{
                    required: true,
                    message: 'Selecciona tipo de documento',
                    trigger: 'change'
                }],
                ndocument: [{
                    required: true,
                    message: 'Falta número de documento',
                    trigger: ['blur', 'change']
                },{validator: validateDocument, trigger: ['change', 'blur']}],
                firstname: [{
                    required: true,
                    message: 'Falta nombres completos',
                    trigger: 'blur'
                }],
                phone1: [{
                    required: true,
                    message: 'Falta celular',
                    trigger: 'blur'
                }],
                address: [{
                    required: true,
                    message: 'Falta ingresar dirección',
                    trigger: 'blur'
                }],
                email: [{
                    required: true,
                    message: 'Falta ingresar correo electrónico',
                    trigger: ['blur', 'change']
                }, {
                    type: 'email',
                    message: 'Ingrese dirección de correo electrónico correcta',
                    trigger: ['blur', 'change']
                }],
                fndoc: [{
                    required: true,
                    message: 'Ingrese nro. documento',
                    trigger:  ['change', 'blur']
                }, {validator: validateDocument, trigger: ['change', 'blur']}],
                fname: [{
                    required: true,
                    message: 'Ingrese la información solicitada ',
                    trigger: 'blur'
                }, ],
                fphone: [{
                        required: true,
                        message: 'Ingrese un número de celular'
                    },
                    {
                        type: 'number',
                        message: 'Celular debe ser números'
                    }
                ],
                femail: [{
                        required: true,
                        message: 'Ingrese una dirección de correo electrónico',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: 'Ingrese una dirección de correo electrónico correcta',
                        trigger: ['blur', 'change']
                    }
                ],
                terms: [{
                    required: true,
                    message: 'Falta seleccionar los terminos',
                    trigger: ['blur', 'change']
                }]
            },

        }
    },
    computed: {
        maxlength: function() {
            return (this.ruleForm.tdocument == '01' || this.ruleForm.voucher == 'B') ? 8 : 11
        },
        maxlengthTwo: function() {
            return (this.ruleForm.voucher == 'B') ? 8 : 11
        }
    },
    methods: {
        isNumber(evt) {
          if(this.ruleForm.tdocument == '01')
            if (!/^[0-9]+$/.test(evt.key) || evt.key === '.') return evt.preventDefault();
        },
        isNumberTwo(evt) {
          if(this.ruleForm.voucher == 'B' || this.ruleForm.voucher == 'F')
            if (!/^[0-9]+$/.test(evt.key) || evt.key === '.') return evt.preventDefault();
        },
        openModal(a){
            this.ruleForm.precio = a;
            this.dialogVisible = true;
        },
        changeTpodocument(){
            this.placeHolder.voucher = (this.ruleForm.voucher == 'B') ? 'DNI' : 'RUC';
            this.placeHolder.namebussines = (this.ruleForm.voucher == 'B') ? 'Nombres' : 'Razon social';
        },
        formDatas(obj) {
            let formData = new FormData();
            for (var key in obj) {
                formData.append(key, obj[key]);
            }
            return formData;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.active < this.totalSteps) this.active++;
                    if (this.active == this.totalSteps) {
                        this.active--;
                    }

                    if (this.ruleForm.terms == true){
                        let formDatas = this.formDatas(this.ruleForm);
                        axios.post(`${process.env.API1}/subastas/register`, formDatas).then(response => {
                            this.fullscreenLoading = false;
                            if (response.data.status == 'success') {
                                window.location.href = response.data.url
                            } else {
                                this.$alert(response.data.message, 'Lo sentimos!', {
                                    confirmButtonText: 'Entendido',
                                    type: 'error',
                                    center: true,
                                    callback: action => {}
                                });
                            }
                        });
                    }
                }

            });
        }
    }
}
</script>
<style>
.input-with-select .el-select .el-input {
    width: 150px !important;
}
.mdsubasta .el-dialog__body{padding-top: 5px; padding-bottom: 5px;}
@media screen and (max-width: 780px) {
    .single-promo-1{
        width: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/subastas/index.vue